const ratedPuzzles: string[] = [];

export function canRatePuzzle(id: string): boolean {
  return false;
  // return !ratedPuzzles.includes(id);
}

export function markPuzzleRating(id: string): void {
  ratedPuzzles.push(id);
}
